<div class="panel panel-default">
  <div class="panel-heading">
    <div class="menu-bar-container">
      <ng-content select="[projection-location='menu-bar']"></ng-content>
    </div>

    <h3-right-collapsing-button
      *ngIf="(isInSplitView$ | async) !== true"
    ></h3-right-collapsing-button>
  </div>

  <ng-content></ng-content>
</div>
